import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { faqs } from '@/mocks/comicData';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <span className="h-px w-8 bg-primary-500" />
              常见问题
              <span className="h-px w-8 bg-primary-500" />
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black md:text-4xl">关于这部漫画，你可能想问</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              把读者最常问的几个问题集中回答，帮你更快决定要不要入坑、该从哪卷开始追。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={item.q} delay={i * 50}>
                <div
                  className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                    isOpen ? 'border-primary-300' : 'border-background-200/70'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-heading text-base font-bold text-foreground-950">{item.q}</span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-primary-100 text-primary-700'
                      }`}
                    >
                      <i className={`ri-add-line transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} />
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{item.a}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}